"use client";

import { c as _c } from "react/compiler-runtime";
import { Separator, SideSheetBody, SideSheetHeader, SideSheetHeaderTitle, UnstyledButton } from "@opensea/ui-kit";
import { ExpandMore } from "@opensea/ui-kit/icons";
import { useTranslations } from "use-intl";
import { MoonPayTopupWidget } from "./MoonpayTopupWidget";
export const TopupFlowContent = t0 => {
  const $ = _c(13);
  const {
    onBack
  } = t0;
  const t = useTranslations("wallet.TopupFlowContent");
  let t1;
  if ($[0] !== onBack) {
    t1 = onBack && <UnstyledButton onClick={onBack}><ExpandMore className="rotate-90" size={24} title="Back" /></UnstyledButton>;
    $[0] = onBack;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("title");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <SideSheetHeaderTitle>{t2}</SideSheetHeaderTitle>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <SideSheetHeader className="gap-4">{t1}{t3}</SideSheetHeader>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Separator />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SideSheetBody className="flex grow flex-col items-center justify-center py-6"><MoonPayTopupWidget /></SideSheetBody>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4) {
    t7 = <>{t4}{t5}{t6}</>;
    $[11] = t4;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};